import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchSubAccount'
})
export class SearchSubAccountPipe implements PipeTransform {

  transform(arr: any, code: any): any {
    if ( code == '' || code == null || code == undefined || code == 'undefined' || code == 'All' || arr == [] || arr == undefined || arr == null) {
      return[];
    } else{
      return arr.filter((arr: any) =>{
        return arr.accountsguide_id == code
      })
    }
  }

}
